import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { orderBy } from 'lodash';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { getCountriesByISO } from '../api/countries';
import { apiGetCountries, apiGetCurrencies } from '../api/resourceApi';
export var useCountryStore = create()(immer(function (set, get) {
  return {
    state: {
      countries: null,
      currencies: null,
      currencySelectOptions: [],
      currencySelectOptionsWithCode: [],
      isLoading: false,
      euCountries: []
    },
    actions: {
      initialize: function () {
        var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _get$actions, fetchCountries, fetchCurrencies;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  set(function (store) {
                    store.state.isLoading = true;
                  });
                  _get$actions = get().actions, fetchCountries = _get$actions.fetchCountries, fetchCurrencies = _get$actions.fetchCurrencies;
                  _context.next = 4;
                  return fetchCountries();

                case 4:
                  _context.next = 6;
                  return fetchCurrencies();

                case 6:
                  set(function (store) {
                    store.state.isLoading = false;
                  });

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function initialize() {
          return _initialize.apply(this, arguments);
        }

        return initialize;
      }(),
      fetchCountries: function () {
        var _fetchCountries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var countries, _yield$apiGetCountrie, _yield$apiGetCountrie2, countriesRes, err;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  countries = get().state.countries;

                  if (!countries) {
                    _context2.next = 3;
                    break;
                  }

                  return _context2.abrupt("return");

                case 3:
                  _context2.next = 5;
                  return apiGetCountries({});

                case 5:
                  _yield$apiGetCountrie = _context2.sent;
                  _yield$apiGetCountrie2 = _slicedToArray(_yield$apiGetCountrie, 2);
                  countriesRes = _yield$apiGetCountrie2[0];
                  err = _yield$apiGetCountrie2[1];
                  set(function (store) {
                    var _countriesRes$data;

                    store.state.countries = ((_countriesRes$data = countriesRes === null || countriesRes === void 0 ? void 0 : countriesRes.data) !== null && _countriesRes$data !== void 0 ? _countriesRes$data : []).map(function (item) {
                      item['value'] = item.code;
                      item['label'] = item.name;
                      (item.currencies || []).forEach(function (aItem) {
                        aItem['value'] = aItem.code;
                        aItem['label'] = aItem.name;
                      });
                      return item;
                    });
                  });

                case 10:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function fetchCountries() {
          return _fetchCountries.apply(this, arguments);
        }

        return fetchCountries;
      }(),
      fetchCurrencies: function () {
        var _fetchCurrencies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var currencies, _yield$apiGetCurrenci, _yield$apiGetCurrenci2, currenciesRes, err;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  currencies = get().state.currencies;

                  if (!currencies) {
                    _context3.next = 3;
                    break;
                  }

                  return _context3.abrupt("return");

                case 3:
                  _context3.next = 5;
                  return apiGetCurrencies({});

                case 5:
                  _yield$apiGetCurrenci = _context3.sent;
                  _yield$apiGetCurrenci2 = _slicedToArray(_yield$apiGetCurrenci, 2);
                  currenciesRes = _yield$apiGetCurrenci2[0];
                  err = _yield$apiGetCurrenci2[1];
                  set(function (store) {
                    var currencyList = (currenciesRes === null || currenciesRes === void 0 ? void 0 : currenciesRes.data) || [];
                    store.state.currencies = currencyList;
                    store.state.currencySelectOptions = orderBy(currencyList.map(function (currency) {
                      return _objectSpread(_objectSpread({}, currency), {}, {
                        value: currency.code,
                        label: "".concat(currency.name, " (").concat(currency.symbol, ")")
                      });
                    }), ['label']);
                    store.state.currencySelectOptionsWithCode = orderBy(currencyList.map(function (currency) {
                      return _objectSpread(_objectSpread({}, currency), {}, {
                        value: currency.code,
                        label: currency.code
                      });
                    }), ['label']);
                  });

                case 10:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function fetchCurrencies() {
          return _fetchCurrencies.apply(this, arguments);
        }

        return fetchCurrencies;
      }(),
      fetchEUCountries: function () {
        var _fetchEUCountries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var euList, res;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  euList = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DE', 'DK', 'EE', 'FI', 'FR', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
                  _context4.next = 3;
                  return getCountriesByISO(euList);

                case 3:
                  res = _context4.sent;
                  set(function (store) {
                    store.state.euCountries = ((res === null || res === void 0 ? void 0 : res.data) || []).map(function (item) {
                      return _objectSpread(_objectSpread({}, item), {}, {
                        label: item.name,
                        value: item.code
                      });
                    }).sort(function (pre, suf) {
                      return pre.label.localeCompare(suf.label);
                    });
                  });

                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        function fetchEUCountries() {
          return _fetchEUCountries.apply(this, arguments);
        }

        return fetchEUCountries;
      }()
    }
  };
}));